// extracted by mini-css-extract-plugin
module.exports = {"comp":"Animation3D_comp__O1Rrq"};